import React from 'react';
import { SUPER_GENRE_COLOR_MAP } from '../utils/genreUtils';

const GenreBarcode = ({ 
    script, 
    showGenreLabels = false, 
    showLabelsOnHover = true, 
    showExpandIcon = true,
    onClick // Pass the handler from parent to open modal
}) => {
    // Safety check for data
    if (!script || !script.genres_taxonomy) {
        return <div className="text-danger">No genre data</div>;
    }

    // Parse taxonomy if string, otherwise use as is
    const taxonomy = typeof script.genres_taxonomy === 'string' 
        ? JSON.parse(script.genres_taxonomy) 
        : script.genres_taxonomy;

    const superGenres = (taxonomy.children || []).filter(g => g.type === 'Super-genre');

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
            onClick({
                taxonomy: taxonomy,
                title: script.title || 'Unknown Script',
                id: script.hash || script.id
            });
        }
    };

    return (
        <div className="genre-barcode-container">
            <style jsx>{`
                .genre-barcode {
                    display: flex;
                    gap: 2px;
                    height: 24px;
                    width: 100%;
                    border-radius: 4px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: transform 0.2s, box-shadow 0.2s;
                }
                .genre-barcode:hover {
                    transform: scale(1.02);
                    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
                }
                .genre-barcode span:hover {
                    opacity: 0.85;
                }
                .hover-text {
                    opacity: 0;
                    max-height: 0;
                    overflow: hidden;
                    transition: all 0.3s;
                }
                .genre-barcode-container:hover .hover-text {
                    opacity: 1;
                    max-height: 50px;
                }
            `}</style>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div 
                    className="genre-barcode flex-grow-1"
                    role="button"
                    onClick={handleClick}
                    title={`View genre analysis for ${script.title}`}
                >
                    {superGenres.map((genre, idx) => (
                        <span
                            key={idx}
                            style={{
                                backgroundColor: SUPER_GENRE_COLOR_MAP[genre.name] || '#adb5bd',
                                flex: genre.coverage || genre.strength
                            }}
                            title={`${genre.name}: ${genre.coverage || genre.strength}% coverage`}
                        />
                    ))}
                </div>

                {showExpandIcon && (
                    <i 
                        className="fa fa-external-link text-muted"
                        style={{ fontSize: '14px', cursor: 'pointer' }}
                        onClick={handleClick}
                        title="View full analysis"
                    />
                )}
            </div>

            {(showGenreLabels || showLabelsOnHover) && (
                <div 
                    className={`mt-2 ${showGenreLabels ? '' : 'hover-text'}`}
                    style={showGenreLabels ? { opacity: 1, maxHeight: 'none' } : {}}
                >
                    {superGenres.map((genre, idx) => (
                        <span 
                            key={idx} 
                            className="badge me-1" 
                            style={{ backgroundColor: SUPER_GENRE_COLOR_MAP[genre.name] }}
                        >
                            {genre.name} {genre.coverage || genre.strength}%
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GenreBarcode;
